// P5.js Editor Sync Service
// Uses p5mirrorLib functionality to sync sketches

import { useStore } from '../store/useStore'

export async function syncToP5js() {
  const { files, sketchId, sketchName, p5Credentials } = useStore.getState()

  if (!p5Credentials) {
    throw new Error('Not authenticated with p5.js')
  }

  try {
    // Prepare files for upload
    const sketchFiles = files.map(f => ({
      name: f.name,
      content: f.content,
      fileType: 'file'
    }))

    const payload = {
      name: sketchName,
      files: sketchFiles,
      credentials: p5Credentials
    }

    // If sketch exists, update it; otherwise create new
    const endpoint = sketchId ? '/api/p5-update' : '/api/p5-create'
    
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        ...payload,
        sketchId: sketchId
      })
    })

    if (!response.ok) {
      const error = await response.json()
      throw new Error(error.error || 'Sync failed')
    }

    const data = await response.json()

    return {
      success: true,
      sketchId: data.sketchId,
      sketchName: data.name,
      url: `https://editor.p5js.org/${p5Credentials.username}/sketches/${data.sketchId}`
    }
  } catch (error) {
    console.error('Sync error:', error)
    return {
      success: false,
      error: error.message
    }
  }
}

export async function loadFromP5js(sketchId) {
  const { p5Credentials } = useStore.getState()

  if (!p5Credentials) {
    throw new Error('Not authenticated with p5.js')
  }

  try {
    const response = await fetch('/api/p5-load', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        sketchId,
        credentials: p5Credentials
      })
    })

    if (!response.ok) {
      const error = await response.json()
      throw new Error(error.error || 'Load failed')
    }

    const data = await response.json()

    // Update store with loaded sketch
    useStore.getState().setCode(data.files[0]?.content || '')
    useStore.getState().setSketchInfo({
      id: data.id,
      name: data.name
    })

    return {
      success: true,
      sketch: data
    }
  } catch (error) {
    console.error('Load error:', error)
    return {
      success: false,
      error: error.message
    }
  }
}

export async function listUserSketches() {
  const { p5Credentials } = useStore.getState()

  if (!p5Credentials) {
    throw new Error('Not authenticated with p5.js')
  }

  try {
    const response = await fetch('/api/p5-list', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        credentials: p5Credentials
      })
    })

    if (!response.ok) {
      const error = await response.json()
      throw new Error(error.error || 'Failed to list sketches')
    }

    const data = await response.json()
    return data.sketches
  } catch (error) {
    console.error('List error:', error)
    throw error
  }
}
